import service from "./service"

const fetchAuthUser = async () => {
    return service()
}

export default fetchAuthUser
